import { Brain, Loader2, Sparkles } from "lucide-react";

const WaterSafetyGuidanceChip = ({ provider, loading }) => {
  if (loading) {
    return (
      <span className="inf-status-chip blue">
        <Loader2 size={14} className="inline animate-spin mr-1" />
        AI analysing…
      </span>
    );
  }
  if (provider === "mistral") {
    return (
      <span className="inf-status-chip blue">
        <Brain size={14} className="inline mr-1" />
        Mistral-powered
      </span>
    );
  }
  return (
    <span className="inf-status-chip amber">
      <Sparkles size={14} className="inline mr-1" />
      Rule-based fallback
    </span>
  );
};

export default WaterSafetyGuidanceChip;
